import { orderBy, Many, lowerCase } from 'lodash'

/* eslint import/prefer-default-export: "off" */

/**
 * @description
 * This function can easily sort some array by passed field.
 * Also it is supporting optional iterator for custom sort logic
 *
 * @export
 * @param {Array} array array to sort
 * @param {String} field sort by field
 * @param {Function} [iterator=(x, y) => 0] iterator for custom logic, where should return
 * (-1 - x is less that y; 1 - x is greater than y; 0 - should use default logic)
 * @returns sorted array
 */
export function sortByField<T>(
  array: T[],
  field: keyof T,
  iterator = <T>(x: T, y: T) => 0
) {
  return array.sort((x, y) => {
    const res = iterator(x, y)
    if (res !== 0) return iterator(x, y)
    if (x[field] < y[field]) return -1
    if (x[field] > y[field]) return 1
    return 0
  })
}

interface OrderByFieldOptions<T> {
  options: T[] | readonly T[]
  key?: keyof T
  orders?: Many<boolean | 'asc' | 'desc'>
}

export function orderByField<T>({
  options = [],
  key,
  orders = 'asc'
}: OrderByFieldOptions<T>) {
  return (
    orderBy(options, x => lowerCase(String(key ? x[key] : x)), orders) || []
  )
}
